module.exports = __webpack_public_path__ + "img/io.c1f8468a.svg";